<!--主布局-->
<template>
    <div>
        <slot></slot>
    </div>
</template>

<script>
export default {
    name: 'MainView',
};
</script>
